import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { Document } from '@contentful/rich-text-types';
import { RichText } from '../../richText';

interface CaseStudyContentAndMobileImagesProps {
  content: Document;
  mobileImage1: Asset;
  mobileImage2: Asset;
  contentLocation: string;
}

const Phone = styled.div`
  background-color: #ccc;
  padding:3rem 1rem;
  border-radius: 1.5rem;
  box-shadow:5px 5px 20px -2px rgba(0,0,0,0.5);
  max-width: 280px;
  margin: auto;

  @media(min-width: 1024px){
    max-width: 220px;
    padding:2.5rem 0.75rem;
  }
`;

export const CaseStudyContentAndMobileImages: React.FC<CaseStudyContentAndMobileImagesProps> = ({
  content,
  mobileImage1,
  mobileImage2,
  contentLocation,
}) => {

  return (
    <div className={`cs-block-natural w-full max-w-6xl px-8 pb-20 lg:pb-32 lg:flex lg:mx-auto lg:gap-5 ${contentLocation === 'Right' ? 'flex-row-reverse' : 'flex-row'}`}>
      <div className="mb-12 lg:w-1/2">
        <RichText content={content} />
      </div>
      <div className="lg:w-1/2">
        <div className="pb-10 lg:m-auto md:flex lg:mx-2">
          <Phone className="mb-10 md:mb-0">
            <img src={mobileImage1.url} alt={mobileImage1.name} className={'object-cover w-full h-full'}/>
          </Phone>
          <Phone>
            <img src={mobileImage2.url} alt={mobileImage2.name} className={'object-cover w-full h-full'}/>
          </Phone>
        </div>
      </div>

    </div>
  );
};
